__turbopack_context__.v({
  "closeButton": "ModalHeader-module-scss-module__bkZbxW__closeButton",
  "eyebrow": "ModalHeader-module-scss-module__bkZbxW__eyebrow",
  "titleGroup": "ModalHeader-module-scss-module__bkZbxW__titleGroup",
});
